import * as React from "react";
const SVGComponent = ({ color = "#333433", ...props }) => (
  <svg
    width={12}
    height={15}
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.04691 14.6974C0.790137 8.5263 0 7.89296 0 5.625C0 2.51839 2.51839 0 5.625 0C8.73161 0 11.25 2.51839 11.25 5.625C11.25 7.89296 10.4599 8.5263 6.20309 14.6974C5.92374 15.1009 5.32623 15.1009 5.04691 14.6974ZM5.625 7.96875C6.91942 7.96875 7.96875 6.91942 7.96875 5.625C7.96875 4.33058 6.91942 3.28125 5.625 3.28125C4.33058 3.28125 3.28125 4.33058 3.28125 5.625C3.28125 6.91942 4.33058 7.96875 5.625 7.96875Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;